import { render, staticRenderFns } from "./MaterialOwnSourceItem.vue?vue&type=template&id=5075af02&scoped=true&"
import script from "./MaterialOwnSourceItem.vue?vue&type=script&lang=js&"
export * from "./MaterialOwnSourceItem.vue?vue&type=script&lang=js&"
import style0 from "./materialOwnSource.styl?vue&type=style&index=0&id=5075af02&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5075af02",
  null
  
)

export default component.exports